import { z } from "zod";

// clean input and then check if it's valid
export const booleanString = () =>
  z.enum(["true", "false"]).transform((value) => value === "true");
